import React, { useEffect, useState } from "react";
import { Breadcrumb, Row, Col, Card,Table, BackTop, Tooltip, Space, Avatar, Typography, Button, Select, Radio } from 'antd';
import { fetchAdminApi, fetchApi } from "../../../services/api";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import { CheckCircleOutlined, CommentOutlined, FlagFilled, RollbackOutlined } from '@ant-design/icons';
import constants from "../../../constants/constants";
import moment from "moment";
const { Text } = Typography;
const TestAnalysis = () => {
	const { Option } = Select;
	const history = useHistory();
	const location = useLocation();
	const [testAnalysis,setTestAnalysis]=useState([]);
	const [totals, setTotals] = useState(null);
	const [userID, setUserID] = useState(null);
	const [categoryOptionId, setCategoryOptionId] = useState([]);
	const [topicOptionId, setTopicOptionId] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState("");
	const [selectedTopic, setSelectedTopic] = useState("");
	const [selectedStatus, setSelectedStatus] = useState("");
	const storedData = sessionStorage.getItem("testAnalysisData");
	const parsedData = storedData ? JSON.parse(storedData) : {};
	const scoreId = location.state?.scoreId || parsedData?.scoreId;
	const is_active = location.state?.is_active || parsedData?.is_active;
	const initial = location.state?.initial || parsedData?.initial;
	const username = location.state?.username || parsedData?.username;
	const test_length = location.state?.test_length || parsedData?.test_length;
	const total_questions = location.state?.total_questions || parsedData?.total_questions;
	const test_taken_date = location.state?.test_taken_date || parsedData?.test_taken_date;
	const test_result = location.state?.test_result || parsedData?.test_result;
	useEffect(() => {
		fetchCategoryOption();
		fetchTopicOption();
	}, []);
	const faqDisplay = [
		{
			label: 'All',
			value: '',
		},
		{
			label: 'Correct',
			value: '1',
		},
		{
			label: 'Incorrect',
			value: '2' , 
		},
		{
			label: 'Not Answered',
			value: '3' , 
		},
		{
			label: 'Marked',
			value: '4' , 
		},
	];
	const columns = [
		{
			title: 'Qn #',
			key: 'no',
			align: 'center',
			render: (text, record, index) => index + 1,
		},
		{
			title: 'Qn Id',
			dataIndex: 'question_id',
			key: 'question_id',
			align: 'center',
			render: (question_id,allData) => (
				<span><a
					onClick={() => {
						const testAnalysisState = {
							scoreId,
							is_active,
							initial,
							username,
							test_length,
							total_questions,
							test_taken_date,
							test_result
						};
						sessionStorage.setItem("testAnalysisData", JSON.stringify(testAnalysisState));
						sessionStorage.setItem("questionId", allData?.question_id);
						sessionStorage.setItem("questionImage", allData?.image_name);
						sessionStorage.setItem("testAnalysis", 1);
						window.open(constants.BaseUrl+"/edit-question", "_blank");
					}}
				>{question_id}</a></span>
			),
			sorter: (a, b) => a.question_id - b.question_id,
		},
		{
			title: 'Correct Answer',
			dataIndex: 'answer',
			key: 'answer',
			align: 'center',
		},
		{
			title: 'Answered Correctly',
			dataIndex: 'correct_answer',
			key: 'correct_answer',
			align: 'center',
			render: (value) => value === 1 ? <CheckCircleOutlined style={{
				fontSize:"large",
				color:"green" 
			}}/> : null,
			sorter: (a, b) =>
				(b.correct_answer || 0) - (a.correct_answer || 0),
		},
		{
			title: 'Answered Incorrectly',
			dataIndex: 'incorrect_answer',
			key: 'incorrect_answer',
			align: 'center',
			sorter: (a, b) => {
				const valA = a.incorrect_answer || "Z";
				const valB = b.incorrect_answer || "Z";
				return valA.localeCompare(valB);
			}
		},
		{
			title: 'Not Answered',
			dataIndex: 'not_answered',
			key: 'not_answered',
			align: 'center',
			sorter: (a, b) => {
				const valA = a.not_answered || "Z";
				const valB = b.not_answered || "Z";
				return valA.localeCompare(valB);
			}
		},
		{
			title: 'Marked',
			dataIndex: 'marked',
			key: 'marked',
			align: 'center',
			render: (value) => value === 1 ? <FlagFilled className="flag"/> : null,
			sorter: (a, b) =>
				(b.marked || 0) - (a.marked || 0),
		},
		{
			title: 'Rating',
			dataIndex: 'rating',
			key: 'rating',
			align: 'center',
			sorter: (a, b) => a.rating?.localeCompare(b.rating),
		},
		{
			title: 'Notes',
			dataIndex: 'note',
			key: 'note',
			align: 'center',
			render: (value) => value ? <Tooltip title={value}><CommentOutlined/></Tooltip> : null,
		},
		{
			title: 'Category',
			dataIndex: 'category',
			key: 'category',
			align: 'center',
			sorter: (a, b) => a.category?.localeCompare(b.category),
		},
		{
			title: 'Topic',
			dataIndex: 'topic',
			key: 'topic',
			align: 'center',
			sorter: (a, b) => a.topic?.localeCompare(b.topic),
		},
		{
			title: 'Repeat',
			dataIndex: 'duplicate',
			key: 'duplicate',
			align: 'right',
			render: (value) => value === 0 ? null : value,
			sortDirections: ['ascend', 'descend'],
			sorter: (a, b) => a.duplicate - b.duplicate,
		},
	];
	useEffect(() => {
		if (scoreId) {
			fetchTestAnalysis();
		}
	}, [scoreId, selectedCategory, selectedTopic, selectedStatus]);
	const fetchTestAnalysis = () => {
		let payload = {
			score_card_id: scoreId,
			is_table: 1
		};
		if (selectedCategory) {
			payload.category = selectedCategory;
		}
		if (selectedTopic) {
			payload.topic = selectedTopic;
		}
		if (selectedStatus) {
			payload.status = selectedStatus;
		}
		fetchApi(`/scorecard-details`, "post", payload).then(
			(res) => {
				if (res && res?.data) {
					setTestAnalysis(res?.data?.questions_data);
					setTotals(res?.data?.totals);
					setUserID(res?.data?.student_id);
				} else {
					setTestAnalysis([]);
					setTotals(null);
					setUserID(null);
				}
			}
		);
	};
	const fetchCategoryOption = () => {
		fetchAdminApi("/test-listing?type=category_options", "get").then((res) => {
			if (res && res.data) {
				setCategoryOptionId(res.data);
			}
			else {
				setCategoryOptionId([]);
			}
		});
	};
	const fetchTopicOption = () => {
		fetchAdminApi("/test-listing?type=topic_options", "get").then((res) => {
			if (res && res.data) {
				setTopicOptionId(res.data);
			}
			else {
				setTopicOptionId([]);
			}
		});
	};
	const returnToPrevieousPage = () =>{
		if (test_result === 1) {
			history.push({ pathname :"/test-result" });
		} else {
			history.push({ pathname :"/full-length-result-page" });
		}
	};
	const selectFilterOption = (input,option)=>{
		return option.props.children.toLowerCase().includes(input.toLowerCase());
	};
	return(
		<>
			<div className="div">
				<BackTop/>
				<div className="p-3">
					<Breadcrumb>
						<Breadcrumb.Item ><a onClick={() => {
							history.push({ pathname: "/admin-dashboard" });
						}}>{constants.Home}</a></Breadcrumb.Item>
						<Breadcrumb.Item ><a onClick = {() => {
							history.push({ pathname :"/analysis-menu" });
						}}>{constants.Analysis}</a></Breadcrumb.Item>
						<Breadcrumb.Item ><a onClick = {() => {
							history.push({ pathname :"/test-results" });
						}}>{constants.testResults}</a></Breadcrumb.Item>
						<Breadcrumb.Item ><a onClick={returnToPrevieousPage}>Results</a></Breadcrumb.Item>
						<Breadcrumb.Item>{constants.TestAnalysis}</Breadcrumb.Item>
					</Breadcrumb>
				</div>
				<div>
					<Row gutter={[24, 24]}>
						<Col xs={24} sm={24} md={24} lg={24}>
							<Card size="small" title={<span className="text-uppercase">{constants.TestAnalysis}</span>}>
								<Col span={24} className="mb-2">
									<Row className="user-detail-wrapper">
										<Col span={24}>
											<Space size="middle" wrap>
												<Avatar size={64} className="avatar mr-2 my-auto" >{is_active==="4"?"#":initial}</Avatar>
												<div className="user-details">
													<p className="user-name-result" onClick={() => {
														sessionStorage.setItem("showEditSaveButton", "show");
														sessionStorage.setItem("studentId", userID);
														sessionStorage.setItem("dashboard", "true");
														window.open(constants.BaseUrl + "/edit-student", "_blank");
													}}
													style={{ cursor: "pointer" }}>{is_active==="4"?"-":username}</p>
													<Space wrap>
														<p className="test-name">Test Results of {test_length} - {total_questions} questions </p>
														<p><Text type="secondary" className="test-name">({moment(test_taken_date).format(constants.dateFormat)})</Text></p>
													</Space>
													<div>
														<Space wrap>
															<div>
																<span className="mr-2">{constants.Category}</span>
																<Select 
																	value={selectedCategory}
																	onChange={(value) => setSelectedCategory(value)}
																	placeholder="--Category--"
																	style={{ width: 180 }} 
																	filterOption={selectFilterOption} 
																	showSearch
																	allowClear
																>
																	<Option value={""}>--Category--</Option>
																	{categoryOptionId.map(option => {
																		return <Option key={option.category_id} value={option.category_abbreviation}>{option.category_abbreviation}</Option>;
																	})}
																</Select>
															</div>
															<div>
																<span className="mr-2">{constants.Topic}</span>
																<Select 
																	value={selectedTopic}
																	onChange={(value) => setSelectedTopic(value)}
																	placeholder="--Topic--"
																	style={{ width: 180 }}
																	filterOption={selectFilterOption} 
																	showSearch
																	allowClear
																>
																	<Option value={""}>--Topic--</Option>
																	{topicOptionId.map(option => {
																		return <Option key={option.topic_id} value={option.topic_abbreviation}>{option.topic_abbreviation}</Option>;
																	})}
																</Select>
															</div>
															<Radio.Group value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} options={faqDisplay} optionType="button" buttonStyle="solid"/>
															<Button className="purple-bg" onClick={returnToPrevieousPage}><RollbackOutlined/>{constants.ReturnToResult}</Button>
														</Space>
													</div>
												</div>
											</Space>
										</Col>
									</Row>
								</Col>
								{totals?.test_result && <div className="test-score-font px-3">
									<Space size="large" wrap>
										<span>
											{totals?.test_result === "FAIL" ? "DID NOT PASS" : "PASS"} :
											{" "}{totals?.test_percentage}%
										</span>
										{totals?.total_score && <span>
											SCORE : {totals?.total_score}
										</span>}
									</Space>
								</div>}
								<Table
									className="gap-table"
									dataSource={testAnalysis}
									columns={columns}
									pagination={false}
									rowKey="question_id"
									summary={() => {
										if (!totals || !testAnalysis || testAnalysis.length === 0) return null;
										return (
											<>
												<Table.Summary.Row>
													<Table.Summary.Cell index={0} align="center">
														<b>Total</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={1}/>
													<Table.Summary.Cell index={2}/>
													<Table.Summary.Cell index={3} align="center">
														<b>{totals.total_correct_answers}</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={4} align="center">
														<b>{totals.total_incorrect_answers}</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={5} align="center">
														<b>{totals.total_not_answered_questions}</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={6} align="center">
														<b>{totals.total_marked_questions}</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={7}/>
													<Table.Summary.Cell index={8}/>
													<Table.Summary.Cell index={9}/>
													<Table.Summary.Cell index={10}/>
													<Table.Summary.Cell index={11} align="right"><b>{totals.repeat_count}</b></Table.Summary.Cell>
												</Table.Summary.Row>
												<Table.Summary.Row>
													<Table.Summary.Cell index={0} align="center">
														<b>%</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={1}/>
													<Table.Summary.Cell index={2}/>
													<Table.Summary.Cell index={3} align="center">
														<b>{totals.corr_ans_perc}%</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={4} align="center">
														<b>{totals.incorr_ans_perc}%</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={5} align="center">
														<b>{totals.not_ans_perc}%</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={6} align="center">
														<b>{totals.marked_ans_perc}%</b>
													</Table.Summary.Cell>
													<Table.Summary.Cell index={7}/>
													<Table.Summary.Cell index={8}/>
													<Table.Summary.Cell index={9}/>
													<Table.Summary.Cell index={10}/>
													<Table.Summary.Cell index={11} align="right"><b>{totals.repeat_perc}%</b></Table.Summary.Cell>
												</Table.Summary.Row>
											</>
										);
									}}
								/>
								<div className="d-flex">
									{totals?.fpp_score && (
										<div className="px-3">
											<b>FPP: </b>
											{totals.fpp_score} ({totals.fpp_score_perc}%)
										</div>
									)}
									{totals?.saed_score && (
										<div className="pr-3">
											<b>SAED: </b>
											{totals.saed_score} ({totals.saed_score_perc}%)
										</div>
									)}
									{totals?.piet_score && (
										<div>
											<b>PIET: </b>
											{totals.piet_score} ({totals.piet_score_perc}%)
										</div>
									)}
								</div>
								<div className="d-flex mt-2">
									{totals?.total_time_taken && (
										<div className="px-3">
											<b>Total time: </b>
											{totals.total_time_taken}
										</div>
									)}
									{totals?.average_time && (
										<div className="pr-3">
											<b>Average time per question: </b>
											{totals.average_time}
										</div>
									)}
								</div>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		</>
	);
};
export default TestAnalysis;